import { Link } from "react-router-dom";

export const CTABand = () => (
  <section style={{ background: "var(--navy-700)" }} data-testid="cta-band">
    <div className="container-site section">
      <h2 className="text-h2 mb-3" style={{ color: "#fff" }}>
        Looking for a collaborator?
      </h2>
      <p className="body-lg mb-8 measure" style={{ color: "var(--on-navy)" }}>
        I take on funded research, doctoral supervision, and industry projects where an immersive system has to work in the field rather than in a demo.
      </p>
      <div className="flex flex-wrap gap-4">
        <Link to="/research" className="btn btn-white" data-testid="cta-research-btn">See the research</Link>
        <Link to="/contact" className="btn btn-white-outline" data-testid="cta-contact-btn">Get in touch</Link>
      </div>
    </div>
  </section>
);
